import React, { useMemo } from "react";

export const plotCoordinates = [
  { "id": "plot-h5a", "coords": "1729,2127, 1732,2198, 1928,2194, 1924,2121", "alt": "Plot - 5A" },
  { "id": "plot-h20A", "coords": "2550,2225, 2553,2293, 2724,2276, 2735,2218", "alt": "Plot - 20A" },
  { "id": "plot-h14-9", "coords": "1491,3336, 1502,3426, 1789,3394, 1780,3311", "alt": "Plot - 14/9" },
  { "id": "plot-h14-10", "coords": "1503,3428, 1527,3645, 1822,3628, 1788,3397", "alt": "Plot - 14/10" },
  { "id": "plot-h14-11", "coords": "1473,3165, 1490,3328, 1781,3308, 1762,3148", "alt": "Plot - 14/11" },
  { "id": "plot-h14-12", "coords": "1477,2125, 1475,2202, 1708,2189, 1702,2097", "alt": "Plot - 14/12" },
  { "id": "plot-h14-13", "coords": "1477,2205, 1476,2273, 1711,2259, 1708,2193", "alt": "Plot - 14/13" },
  { "id": "plot-h14-4", "coords": "1477,2277, 1477,2386, 1715,2372, 1709,2262", "alt": "Plot - 14/14" },
  { "id": "plot-h15-3", "coords": "1933,1291, 1919,1808, 2124,1806, 2123,1285", "alt": "Plot - 15/3" },
  { "id": "plot-h15-4", "coords": "1722,1287, 1709,1555, 1920,1552, 1929,1291", "alt": "Plot - 15/4" },
  { "id": "plot-h15-5", "coords": "1709,1559, 1698,1808, 1915,1807, 1920,1559", "alt": "Plot - 15/5" },
  { "id": "plot-h1", "coords": "1709,1850, 1718,1978, 1922,1975, 1919,1845", "alt": "Plot - 1" },
  { "id": "plot-h2", "coords": "1923,1847, 1925,1973, 2127,1970, 2126,1844", "alt": "Plot - 2" },
  { "id": "plot-h3", "coords": "1720,1981, 1725,2051, 1922,2046, 1921,1977", "alt": "Plot - 3" },
  { "id": "plot-h4", "coords": "1925,1977, 1925,2104, 2128,2100, 2126,1975", "alt": "Plot - 4" },
  { "id": "plot-h5", "coords": "1722,2053, 1727,2121, 1924,2119, 1921,2049", "alt": "Plot - 5" },
  { "id": "plot-h6", "coords": "1926,2108, 1930,2186, 2130,2181, 2127,2104", "alt": "Plot - 6" },
  { "id": "plot-h7", "coords": "1731,2200, 1734,2268, 1931,2267, 1927,2197", "alt": "Plot - 7" },
  { "id": "plot-h8", "coords": "1929,2189, 1934,2267, 2129,2261, 2130,2183", "alt": "Plot - 8" },
  { "id": "plot-h9", "coords": "1931,2268, 1933,2355, 2130,2334, 2131,2264", "alt": "Plot - 9" },
  { "id": "plot-h10", "coords": "1735,2275, 1739,2370, 1929,2353, 1927,2270", "alt": "Plot - 10" },
  { "id": "plot-h11", "coords": "2157,1844, 2157,1960, 2388,1958, 2390,1841", "alt": "Plot - 11" },
  { "id": "plot-h12", "coords": "2157,1966, 2159,2081, 2388,2077, 2387,1963", "alt": "Plot - 12" },
  { "id": "plot-h13", "coords": "2158,2085, 2157,2200, 2390,2199, 2390,2082", "alt": "Plot - 13" },
  { "id": "plot-h14", "coords": "2157,2206, 2157,2330, 2390,2307, 2390,2203", "alt": "Plot - 14" },
  { "id": "plot-h15", "coords": "2418,1840, 2419,1979, 2606,1974, 2605,1837", "alt": "Plot - 15" },
  { "id": "plot-h16", "coords": "2419,1982, 2419,2173, 2550,2171, 2548,1980", "alt": "Plot - 16" },
  { "id": "plot-h17", "coords": "2417,2177, 2418,2306, 2549,2292, 2549,2175", "alt": "Plot - 17" },
  { "id": "plot-h18", "coords": "2609,1840, 2609,1975, 2782,1969, 2808,1834", "alt": "Plot - 18" },
  { "id": "plot-h19", "coords": "2550,1980, 2552,2119, 2756,2115, 2781,1972", "alt": "Plot - 19" },
  { "id": "plot-h20", "coords": "2552,2124, 2551,2220, 2735,2216, 2755,2117", "alt": "Plot - 20" },
  { "id": "plot-h21", "coords": "1741,2399, 1746,2530, 1940,2514, 1933,2380", "alt": "Plot - 21" },
  { "id": "plot-h22", "coords": "1747,2536, 1756,2668, 1950,2647, 1939,2518", "alt": "Plot - 22" },
  { "id": "plot-h23", "coords": "1758,2670, 1766,2801, 1957,2784, 1950,2650", "alt": "Plot - 23" },
  { "id": "plot-h24", "coords": "1767,2805, 1773,2938, 1967,2918, 1957,2786", "alt": "Plot - 24" },
  { "id": "plot-h25", "coords": "1773,2941, 1782,3079, 1958,3047, 1947,2924", "alt": "Plot - 25" },
  { "id": "plot-h26", "coords": "1936,2381, 1943,2511, 2138,2491, 2130,2361", "alt": "Plot - 26" },
  { "id": "plot-h27", "coords": "1943,2516, 1950,2604, 2145,2585, 2138,2495", "alt": "Plot - 27" },
  { "id": "plot-h28", "coords": "1949,2607, 1954,2694, 2150,2675, 2144,2588", "alt": "Plot - 28" },
  { "id": "plot-h29", "coords": "1954,2699, 1959,2783, 2153,2763, 2148,2680", "alt": "Plot - 29" },
  { "id": "plot-h30", "coords": "1959,2787, 1967,2884, 2161,2866, 2154,2765", "alt": "Plot - 30" },
  { "id": "plot-h31", "coords": "1967,2887, 1969,2917, 1969,2921, 1949,2923, 1953,2967, 2166,2940, 2161,2868", "alt": "Plot - 31" },
  { "id": "plot-h32", "coords": "1954,2971, 1961,3049, 2170,3010, 2166,2942", "alt": "Plot - 32" },
  { "id": "plot-h33", "coords": "2160,2361, 2169,2576, 2405,2551, 2390,2336", "alt": "Plot - 33" },
  { "id": "plot-h34", "coords": "2172,2578, 2178,2668, 2414,2647, 2406,2553", "alt": "Plot - 34" },
  { "id": "plot-h35", "coords": "2177,2674, 2182,2763, 2420,2738, 2415,2650", "alt": "Plot - 35" },
  { "id": "plot-h36", "coords": "2181,2767, 2186,2846, 2424,2818, 2421,2741", "alt": "Plot - 36" },
  { "id": "plot-h37", "coords": "2186,2848, 2191,2925, 2426,2889, 2423,2820", "alt": "Plot - 37" },
  { "id": "plot-h38", "coords": "2191,2928, 2196,3003, 2433,2961, 2428,2892", "alt": "Plot - 38" },
  { "id": "plot-h39", "coords": "2420,2334, 2432,2503, 2566,2496, 2551,2320", "alt": "Plot - 39" },
  { "id": "plot-h40", "coords": "2433,2506, 2438,2630, 2568,2620, 2564,2500", "alt": "Plot - 40" },
  { "id": "plot-h41", "coords": "2438,2633, 2450,2774, 2571,2762, 2568,2622", "alt": "Plot - 41" },
  { "id": "plot-h42", "coords": "2450,2776, 2462,2955, 2579,2934, 2572,2766", "alt": "Plot - 42" },
  { "id": "plot-h43", "coords": "2568,2546, 2574,2710, 2695,2703, 2704,2543", "alt": "Plot - 43" },
  { "id": "plot-h44", "coords": "2574,2713, 2582,2932, 2682,2918, 2695,2707", "alt": "Plot - 44" },
  { "id": "plot-h45", "coords": "1789,3107, 1813,3296, 1932,3277, 1907,3084", "alt": "Plot - 45" },
  { "id": "plot-h46", "coords": "1910,3086, 1935,3275, 2070,3248, 2040,3059", "alt": "Plot - 46" },
  { "id": "plot-h47", "coords": "2043,3059, 2075,3246, 2178,3229, 2169,3037", "alt": "Plot - 47" },
  { "id": "plot-h48", "coords": "2199,3032, 2209,3225, 2329,3204, 2320,3009", "alt": "Plot - 48" },
  { "id": "plot-h49", "coords": "2332,3201, 2468,3176, 2453,2985, 2322,3011", "alt": "Plot - 49" },
  { "id": "plot-h50", "coords": "2456,2985, 2472,3176, 2615,3151, 2585,2962", "alt": "Plot - 50" },
  { "id": "plot-h51", "coords": "2588,2961, 2619,3150, 2820,3114, 2748,2933", "alt": "Plot - 51" },
  { "id": "plot-h52", "coords": "1815,3300, 1842,3500, 1952,3483, 1920,3281", "alt": "Plot - 52" },
  { "id": "plot-h53", "coords": "1923,3280, 1957,3481, 2078,3465, 2047,3258", "alt": "Plot - 53" },
  { "id": "plot-h54", "coords": "2049,3258, 2081,3463, 2190,3448, 2179,3235", "alt": "Plot - 54" },
  { "id": "plot-h55", "coords": "2209,3229, 2218,3440, 2322,3425, 2315,3209", "alt": "Plot - 55" },
  { "id": "plot-h56", "coords": "2318,3208, 2326,3425, 2444,3407, 2432,3187", "alt": "Plot - 56" },
  { "id": "plot-h57", "coords": "2435,3186, 2447,3406, 2561,3388, 2547,3165", "alt": "Plot - 57" },
  { "id": "plot-h58", "coords": "2565,3386, 2683,3368, 2662,3145, 2551,3165", "alt": "Plot - 58" },
  { "id": "plot-h59", "coords": "2665,3143, 2686,3366, 2794,3353, 2775,3123", "alt": "Plot - 59" },
  { "id": "plot-h60", "coords": "2778,3123, 2799,3351, 2907,3335, 2821,3115", "alt": "Plot - 60" },
  { "id": "plot-h61", "coords": "1847,3537, 1869,3706, 1993,3696, 1955,3519", "alt": "Plot - 61" },
  { "id": "plot-h62", "coords": "1957,3520, 1996,3696, 2120,3689, 2083,3501", "alt": "Plot - 62" },
  { "id": "plot-h63", "coords": "2086,3500, 2124,3688, 2196,3684, 2192,3483", "alt": "Plot - 63" },
  { "id": "plot-h64", "coords": "2222,3478, 2235,3680, 2330,3677, 2325,3461", "alt": "Plot - 64" },
  { "id": "plot-h65", "coords": "2329,3461, 2335,3674, 2445,3668, 2432,3445", "alt": "Plot - 65" },
  { "id": "plot-h66", "coords": "2436,3446, 2447,3666, 2525,3665, 2555,3643, 2539,3429", "alt": "Plot - 66" },
  { "id": "plot-h67", "coords": "2545,3427, 2558,3641, 2569,3633, 2695,3572, 2646,3411", "alt": "Plot - 67" },
  { "id": "plot-h68", "coords": "2650,3412, 2697,3570, 2720,3560, 2843,3553, 2779,3392", "alt": "Plot - 68" },
  { "id": "plot-h69", "coords": "2781,3389, 2846,3553, 2985,3540, 2921,3368", "alt": "Plot - 69" },
  { "id": "plot-h70", "coords": "2155,1674, 2160,1806, 2347,1804, 2347,1675", "alt": "Plot - 70" },
  { "id": "plot-h71", "coords": "2156,1598, 2156,1669, 2346,1669, 2348,1598", "alt": "Plot - 71" },
  { "id": "plot-h72", "coords": "2154,1467, 2155,1594, 2345,1594, 2344,1470", "alt": "Plot - 72" },
  { "id": "plot-h73", "coords": "2153,1358, 2154,1464, 2343,1464, 2344,1363", "alt": "Plot - 73" },
  { "id": "plot-h74", "coords": "2152,1204, 2154,1354, 2344,1358, 2345,1298", "alt": "Plot - 74" },
  { "id": "plot-h75", "coords": "2348,1300, 2348,1461, 2545,1461, 2545,1397", "alt": "Plot - 75" },
  { "id": "plot-h76", "coords": "2349,1465, 2349,1568, 2544,1569, 2545,1463", "alt": "Plot - 76" },
  { "id": "plot-h77", "coords": "2348,1571, 2350,1674, 2547,1677, 2545,1572", "alt": "Plot - 77" },
  { "id": "plot-h78", "coords": "2352,1680, 2351,1802, 2543,1803, 2545,1681", "alt": "Plot - 78" },
  { "id": "plot-h79", "coords": "3175,3097, 3167,3260, 3351,3224, 3308,2990", "alt": "Plot - 79" },
  { "id": "plot-h80", "coords": "3312,2987, 3355,3224, 3457,3207, 3410,2950, 3339,2963", "alt": "Plot - 80" },
  { "id": "plot-h81", "coords": "3412,2952, 3459,3204, 3553,3186, 3507,2934", "alt": "Plot - 81" },
  { "id": "plot-h82", "coords": "3510,2934, 3558,3185, 3684,3163, 3636,2907", "alt": "Plot - 82" },
  { "id": "plot-h83", "coords": "3638,2905, 3688,3161, 3816,3141, 3763,2880", "alt": "Plot - 83" },
  { "id": "plot-h84", "coords": "3766,2882, 3819,3140, 3938,3116, 3891,2854", "alt": "Plot - 84" },
  { "id": "plot-h85", "coords": "3896,2856, 3942,3112, 4064,3092, 4014,2830", "alt": "Plot - 85" },
  { "id": "plot-h86", "coords": "3769,2699, 3793,2855, 4009,2809, 3987,2708", "alt": "Plot - 86" },
  { "id": "plot-h87", "coords": "3606,2717, 3639,2884, 3791,2855, 3765,2698, 3653,2688", "alt": "Plot - 87" },
  { "id": "plot-h88", "coords": "3473,2799, 3370,2936, 3634,2883, 3602,2720", "alt": "Plot - 88" },
  { "id": "plot-h14-1", "coords": "1477,1049, 1478,1519, 1695,1514, 1717,1043", "alt": "Plot - 89" },
  { "id": "plot-h14-2", "coords": "1527,3651, 1536,3731, 1543,3739, 1838,3720, 1824,3633", "alt": "Plot - 90" },
  { "id": "plot-h14-3", "coords": "1478,1523, 1475,2122, 1704,2091, 1676,1793, 1694,1517", "alt": "Plot - 91" },
  { "id": "plot-h14-5", "coords": "1402,2568, 1455,3031, 1746,3017, 1723,2555", "alt": "Plot - 92" },
  { "id": "plot-h14-6", "coords": "1458,3038, 1472,3161, 1763,3146, 1748,3083, 1747,3020", "alt": "Plot - 93" },
  { "id": "plot-h14-8", "coords": "1384,2397, 1400,2563, 1724,2550, 1713,2375", "alt": "Plot - 94" }
];

const MapAreas = ({
  imageDimensions,
  hoveredPlotId,
  setHoveredPlotId,
  onPlotClick,
}) => {
  const polygons = useMemo(() => {
    const toPoints = (coords) => {
      const numbers = String(coords)
        .split(",")
        .map((item) => Number(item.trim()))
        .filter((num) => !Number.isNaN(num));

      const pairs = [];
      for (let i = 0; i < numbers.length; i += 2) {
        if (numbers[i] != null && numbers[i + 1] != null) {
          pairs.push(`${numbers[i]},${numbers[i + 1]}`);
        }
      }

      return pairs.join(" ");
    };

    return plotCoordinates.map((plot) => ({
      ...plot,
      points: toPoints(plot.coords),
    }));
  }, []);

  const width = imageDimensions?.width || 1;
  const height = imageDimensions?.height || 1;

  return (
    <svg
      className="map-svg-overlay"
      viewBox={`0 0 ${width} ${height}`}
      preserveAspectRatio="none"
      aria-label="Interactive plot map"
      style={{
        position: "absolute",
        inset: 0,
        width: "100%",
        height: "100%",
        display: "block",
        overflow: "visible",
        pointerEvents: "none",
        zIndex: 30,
      }}
    >
      {polygons.map((plot) => (
        <polygon
          key={plot.id}
          points={plot.points}
          className={`map-plot ${hoveredPlotId === plot.id ? "is-hovered" : ""}`}
          style={{
            pointerEvents: "all",
            cursor: "pointer",
          }}
          onMouseEnter={() => setHoveredPlotId?.(plot.id)}
          onMouseLeave={() => setHoveredPlotId?.(null)}
          onClick={(e) => {
            e.preventDefault();
            e.stopPropagation();
            onPlotClick?.(plot.id);
          }}
        >
          <title>{plot.alt}</title>
        </polygon>
      ))}
    </svg>
  );
};

export default MapAreas;